import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	subHeading: {
		id: 'partner.account.authForm.subHeading',
		defaultMessage: 'Use a personal email address to ensure continued access to your account.',
		description: 'Auth Form subheading',
	},
});
